import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface CostCenter {
  id?: string
  name: string
  code: string
  company_id: string
  parentId?: string
}

export async function getCostCenters(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['cost_centers.company_id = :companyId']
  if (search) {
    where.push(`CONCAT(cost_centers.name,cost_centers.code,parents.code,parents.name) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN cost_centers.code ~ '^[0-9]+$' THEN CAST(cost_centers.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, cost_centers.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN cost_centers.code ~ '^[0-9]+$' THEN CAST(cost_centers.code AS NUMERIC) ELSE NULL END), cost_centers.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_cost_centers'],
    fields: ['cost_centers.id', 'cost_centers.code', 'cost_centers.name', "CONCAT(parents.code,'-',parents.name) as parent",'cost_centers.updated_at', 'cost_centers.is_inactive'],
    join: [
      'LEFT JOIN pg_cost_centers as parents ON pg_cost_centers.parent_id = parents.id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })

  return response
}

export async function getCostCenter(id: string): Promise<CostCenter> {
  const data = await getData<any>({
    tables: ['pg_cost_centers'],
    fields: [
      'id',
      'name',
      'code',
      'company_id as companyId',
      'parent_id as parentId',
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCostCenter(data: CostCenter): Promise<boolean> {
  const response: any = await http.post('payroll/cost-centers', {
    companyId: data.company_id,
    name: data.name,
    code: data.code,
    parentId: data.parentId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }

  return true
}

export async function updateCostCenter(
  data: CostCenter,
  id: string
): Promise<boolean> {
  const response: any = await http.put('payroll/cost-centers/' + id, {
    companyId: data.company_id,
    name: data.name,
    code: data.code,
    parentId: data.parentId,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }

  return true
}

export async function deleteCostCenter(id: string): Promise<boolean> {
  const response: any = await http.delete('payroll/cost-centers/' + id)

  if (response?.data?.data?.error) {
    return false
  }

  return true
}

export async function getCompaniesAccountIntegration() {
  const data = await getData<any>({
    tables: ['pg_companies'],
    fields: ['integrations'],
    where: ['id = :companyId'],
    modifier: ['order by id asc']
  })

  return data[0].results[0].integrations.SAP_SERVICE_LAYER
}

export async function resourceSync(): Promise<string> {
  const response: any = await http.post('integration-action', {
    integrationType: 'sap-service',
    actionType: 'SYNC',
    parameters: {
      entity: 'cost_centers'
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

/* Consultar solicitud de reporte */
export async function getIntegrationAction(id: string) {
  const data = await getData<any>({
    tables: ['pg_integration_actions'],
    fields: ['integration_actions.errors', 'process_status.name as status'],
    join: [
      'INNER JOIN process_status ON integration_actions.process_status_id=process_status.id'
    ],
    where: [`integration_actions.id ='${id}'`]
  })

  return data[0].results[0]
}

export async function stateCostCenter(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`payroll/cost-centers/${id}/enable`, {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
